export const LINKS = {
  home: '/',
  login: '/login',
  logout: '/logout',
  history: '/history',
  historyDetail: (id?: string) => `/history/${id}`
}
